var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.221001 1.75871C-0.0911684 1.45435 -0.0700798 0.979854 0.268104 0.698901C0.606288 0.417948 1.1335 0.436928 1.44567 0.741293L4.779 3.99129C5.07367 4.27859 5.07367 4.72141 4.779 5.00871L1.44567 8.25871C1.1335 8.56307 0.606288 8.58205 0.268104 8.3011C-0.0700798 8.02015 -0.0911684 7.54565 0.221001 7.24129L3.03258 4.5L0.221001 1.75871Z",
    fill: "#1A1A1A",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.ff8f8cb1fa166d30f37a00d4699769dc.svg";
export { ForwardRef as ReactComponent };